<template>
  <div id="tabsTables">
    <div class="tabsTables"  v-if="drawerVisible">
      <a-row type="flex" justify="space-between" align="middle" class="tabeHeader">
        <a-col class="zitiClass" style="font-size: 15px;font-weight: 600;">{{tabsTitle}}</a-col>
        <a-col @click="onCloserDawer" class="ztColor sbxs"><a-icon type="close" style="font-size: 16px;" /></a-col>
      </a-row>
      <a-tabs
              :animated="animated"
              @tabClick="tabClickEvent"
              v-model="targetActive"
      >
        <a-tab-pane :tab="$t('generic.Header')" key='headerKey'>
          <nb-editfrom :QueryUpdatas="headerFromData" apiType="update" v-on:neibucancelModalVisible="neibugetSubvidible" ref="EditFromNbRefs"></nb-editfrom>
        </a-tab-pane >

        <a-tab-pane
              v-for="(item, index) in tabsData"
              :tab="lang == '0' ? item.cnName == null ? item.name : item.cnName : lang == '1' ?  item.tradiCnName == null ? item.name : item.tradiCnName  :  lang == '2' ?  item.enName == null ? item.name : item.enName   : lang == '3' ?  item.korName == null ? item.name : item.korName : lang == '4' ?  item.thName == null ? item.name : item.thName : lang =='5' ? item.jpName == null ? item.name : item.jpName : item.name "
              :key="index">
          <div v-if="isExtraParam == '' || isExtraParam == null">
            <vxe-table-com
                    v-if="subData.columns != undefined"
                    :tableData="subData.data"
                    :cols="subData.columns"
                    ref="subTablsRef"
                    :fixedNum="fixedNum"
                    :key="renderTable"
                    v-on:checkBoxSelectData="getSubBoxSelectData"
                    v-on:selectRowData="dbSelectSubTableChange"
                    :setGmcuid="subTableGmcuid"
                    v-on:renderSearchVal="getredSearchVal"
                    v-on:rederSub="GetrederSub"
                    v-on:renderSortVal="getrenderSortVal"
                    v-on:renderQueryVal="getrenderQueryVal"
                    v-on:sortTableData="GetSortTableData"
                    :loading="subLoading"
                    :tabtype="tabType"
                    :MaxHeight="MaxHeight"
                    :buttonsObj="subFunctionBtn"
            >
              <template slot="topFunction">
                <div style="display: flex;justify-content: space-between;width: calc(100% - 10px);height: 35px;align-items: center;">
                  <div>
                    <function-bar
                            @handleToolClick="subEventclickCall"
                            :buttonsObj="subFunctionBtn"
                    ></function-bar>
                  </div>
                  <div v-if="subData.paging != null">
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => `${$t('generic.totalOf')} ${pagePadding.pagingTotal} ${$t('generic.Records')}`"
                            size="small"
                            :total="pagePadding.pagingTotal"
                            v-model="pagePadding.currentVal"
                            :pageSize.sync="pagePadding.pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                    />

                  </div>
                </div>
              </template>
            </vxe-table-com>
          </div>
          <div v-else-if="isExtraParam == 'Cron'" style="margin-top: 10px;">
            <cron v-on:emitCronVal="getcronSave" :editUid="targetUID"></cron>
          </div>
          <div v-else-if="isExtraParam == 'Cron_schedule'" style="margin-top: 10px;">
            <cron v-on:emitCronVal="getcronSave" :editUid="targetUID"></cron>
          </div>
          <div v-else-if="isExtraParam == 'ruleEnigeDetail'" style="margin-top: 10px;">
            <rule-detail></rule-detail>
          </div>
          <nb-editfrom v-else :QueryUpdatas="subQueryUpdatas" :headerStatus="headerFromData.status" :apiType="subApiType" v-on:neibucancelModalVisible="neibugetSubvidible" ref="EditFromNbRefsComs"></nb-editfrom>
        </a-tab-pane>
      </a-tabs>
    </div>
    <!--sub编辑新增弹窗-->
    <edit-from
            :QueryUpdatas="subQueryUpdatas" :headerStatus="headerFromData.status"
            :visible="subvisible"
            :apiType="subApiType"
            v-on:cancelModalVisible="getSubvidible"
    ></edit-from>
    <de-allocation ref="deAllocation"></de-allocation>
    <look-up ref="lookupRefs" :lookupdata="lookupParams" v-on:propsLookupData="getPropsLookup"
    ></look-up>
    <bath-update
            ref="subBathUpdateRefs"
            v-on:cancelModalVisible="GETcancelModalVisible"
    ></bath-update>
    <split ref="splitRef" v-on:cancelModalVisible="getSubvidible"></split>
    <sort-table-com ref="sortTableRef"></sort-table-com>

    <import-modal
            :visible="importVisible"
            v-on:cancelImport="GETcancelImport"
            :importparams="importparams"
    ></import-modal>
    <modal-sort-table ref="modalSortTableRef" v-on:sortTableData="GetSortTableData"></modal-sort-table>
    <edit-table  ref="editTableRef"></edit-table>
    <Create-from-inventory ref="createFromInventory" v-on:cancelImport="GETcancelImport"></Create-from-inventory>
    <so-edit-table ref="soEditTableRef"  v-on:cancelImport="GETcancelImport"></so-edit-table>
    <so-allocation ref="soAllocationTabRef"  v-on:cancelImport="GETcancelImport"></so-allocation>
    <add-consignment ref="addConsignmentRefs" v-on:cancelImport="GETcancelImport"></add-consignment>
    <create-ticket ref="createTicket" v-on:cancelImport="GETcancelImport"></create-ticket>
    <assigned-user ref="assignedUser" v-on:cancelImport="GETcancelImport"></assigned-user>
    <add-pallet :visible="addPalletVisible" v-on:cancelImport="GETcancelImport" :importparams="importparams"></add-pallet>
    <edit-attachment ref="editAttachment" v-on:cancelImport="GETcancelImport"></edit-attachment>
    <create-ticket-by-new-or-re-count ref="createTicketByNewOrReCount" v-on:cancelImport="GETcancelImport"></create-ticket-by-new-or-re-count>
</div>
</template>
<script>
import functionBar from "./functionBar.vue";
import editFrom from "./editFrom.vue";
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import axios from "axios";
import cookie from "../../../api/cookie";
import { mapState } from "vuex";
import vxeTableCom from "../../com/subTable.vue";
import deAllocation from "../custPage/deAllocation.vue";
import lookUp from "../custPage/lookup.vue";
import bathUpdate from "../custPage/bathUpdate.vue";
import split from "../custPage/split.vue";
import moment from "moment";
import nbEditfrom from './nbEditfrom.vue'
import Cron from './cron.vue'
import ruleDetail from '../custPage/ruleEnigeDetail.vue'
import sortTableCom from "../../com/sortTableCom.vue"
import importModal from "../components/importModal.vue";
import modalSortTable from "../../com/modalSortTable.vue"
import editTable from "../../com/editTable.vue"
import CreateFromInventory from '../../masterData/soCom/CreatefromInventory.vue'
import soEditTable from '../soCom/soEditTable.vue'
import soAllocation from '../soCom/soAllocationEdit.vue'
import addPallet from "../custPage/addPallet.vue";

import addConsignment from '../custPage/addConsignment.vue'
import store from "../../../store";
import CreateTicket from '../custPage/createTicket.vue';
import createTicketByNewOrReCount from '../custPage/createTicketByNewOrReCount.vue';
import AssignedUser from '../custPage/assignedUser.vue';
import editAttachment from '../custPage/editAttachment.vue';
export default {
props: {
  showTitleValue:{
      type: Array,
      default: function() {
          return [];
      }
  },
  allCheckbox:{
      type: Array,
      default: function() {
          return [];
      }
  },
  tabsData: {
      type: Array,
      default: function() {
          return [];
      }
  },
  targetUID:'',
  partStatus:{
    type: String,
    default: function() {
        return "";
    }
  },
    notShowEditPageSaveBtn:{
    type: Boolean,
    default: function() {
          return false;
      }
  },
  parTabelEditVerSion: null, // 没用废弃
  importFunction: {
      type: String,
      default: function() {
          return "0";
      }
  }
},
watch: {
  targetUID(val) {
      this.tabClickEvent('headerKey')
      this.drawerVisible = true
      this.partversion = this.parTabelEditVerSion
      let menuActive = sessionStorage.getItem("menuActive");
      let menuArr = JSON.parse(sessionStorage.getItem("menu"));
      menuArr.forEach((v, i) => {
          if (v.key == menuActive) {
              if(this.showTitleValue.length > 0){
                  this.tabsTitle  = v.funcName + ' - ' + this.showTitleValue
              }else{
                  this.tabsTitle  = v.funcName
              }
              this.$store.commit("updataTabsTitle", { tabsTitle: v.funcName });
          }
      });
  }
},
computed: {
  ...mapState(["lang"])
},
components: {
    addPallet,
  sortTableCom,
  ruleDetail,
  Cron,
  nbEditfrom,
  bathUpdate,
  vxeTableCom,
  functionBar,
  editFrom,
  deAllocation,
  lookUp,
  split,
  importModal,
  modalSortTable,
  editTable,
  CreateFromInventory,
  soEditTable,
  soAllocation,
  addConsignment,
  CreateTicket,
  AssignedUser,
  editAttachment,
  createTicketByNewOrReCount
},

created() {
  this.MaxHeight = document.body.clientHeight - 200;
},
data() {
  return {
      lastActie: null,
      addPalletVisible: false,
      headerFromData: {},
      importVisible: false, // import 传过去的数据
      importparams:{}, // import 传过去的数据
      tabsTitle: '', // 最听不显示的title
      activeKey: [], // 分组下标
     pageSizeOptions:[ '30', '40','100','200','500'],
      pagePadding: { pagingTotal: 0, currentVal: 1, pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30')  }, // 分页
      bathUpdatparams: {}, // bath updata 参数
      lookupParams: {}, // 转给lookup组件参数
      partversion: null, // 父表当前版本好 废弃
      subLoading: false, // tab 中表格加载开关
      form: this.$form.createForm(this),
      patt1: "^(0|[1-9][0-9]*|-[1-9][0-9]*)$", // 整数
      patt2: "^[0-9]+([.]{1}[0-9]+){0,1}$", // 非整数
      patt3: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,64}$/, // 密码
      formItemLayout: {
          labelCol: {
              xs: { span: 24 },
              sm: { span: 8 }
          },
          wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 }
          }
      },
      newGroupSearch: [],
      tarGetId: "", // 纪律当前下拉数据避免重复请求
      targetEditUid: "", // 当前编辑的uid
      parSubselectData: [], // 当前请求的下拉数据
      partEditBtnfn: [], // 按钮内容 part Edit
      editTargetObj: {}, // 父表格的edit 按钮内容
      drawerVisible: false, // drawer开关
      animated: false, // 关闭动画
      targetActive: 'headerKey', // 当前tabs选中卡
      subFunctionBtn: [], // tab卡中表格 btn content
      renderTable: 0, // 是否重新渲染组件
      fixedNum: 0, // 需要固定
      subData: {}, // 子表格数据
      subCheckData: [], // sub表格checkbox 选中
      subTableGmcuid: null,
      subQueryUpdatas: {}, // 传给弹窗内容
      subvisible: false,
      subApiType: "add", // 子表 谈add 还是edit 弹窗
      defaultImg: "", // 图片
      MaxHeight: 0, // table 流体高度
      subTableFunType: "", // sort headersearch adv type
      subTableFunInfo: "",
      isExtraParam: '',
      isExtraParType: '',// add edit
      manualAllocationIndex:-1,//Manual Allocation Tab的坐标
      tabType:"",//区分是哪个Tab页面
      manualAllocationUidList:[],
      nowTabIndex: '',
      pageType: '', //区分父页面
  };
},
methods: {
//      获取cron val
  getcronSave(val){
      let params = val
      if(this.isExtraParam == 'Cron_schedule'){
          if(this.allCheckbox.length  == 0){
              params.uid = this.targetUID
          }else{
              let uids= []
              for(let i in this.allCheckbox){
                  uids.push(this.allCheckbox[i].uid)
              }
              params.uid = uids.join(',')
          }
          params.funcType = 'SCHD_TASK'
      }else{
          params.funcType = 'WAVE'
          params.uid = this.targetUID
      }
      ajax.post(api.WAVECRITERIATRIGGER,params).then(res=>{
          if(res.code == 200){
              this.$message.success(res.msg, 3);
          }else if(res.code == 512){
              this.$customMessage.error(this.$t('easyCron.dayWeekNoset'), 3);
          }else{
              this.$customMessage.error(res.msg, 3);
          }
      })
  },
//      新加内部编辑成功刷新功能
  neibugetSubvidible(val){
      this.tabClickEvent(this.targetActive)
  },

  dbSelectSubTableChange(val,isModel = true){
    let udfEdit = false;
    // 查看当前页面是否为自定义的修改页面
    if (this.subFunctionBtn.length > 0) {
        let btnList = this.subFunctionBtn;
        this.subFunctionBtn.forEach((item,index) => {
            item.children.forEach((item1,index1) => {
                // 符合自定义修改页面
                if (item1.pattern != null && item1.pattern.custPage != null) {
                    if ("BUTTON" === item1.type  && "editAttachment" === item1.pattern.custPage) {
                        udfEdit = true;
                        return;
                    }
                }
            })
        })
        // 如果是自定义修改，直接返回
        if (udfEdit === true){
            this.$refs.editAttachment.show(val.uid,null,this.pageType,this.nowTabIndex)
            return;
        }
    }
    
    let subFun = this.subFunctionBtn
    let editBtn = null
    for(let ii in subFun){
        for(let tt in subFun[ii].children){
            if(subFun[ii].children[tt].code == 'BTN_EDIT'){
                editBtn = subFun[ii].children[tt]
            }
        }
    }
    if(editBtn == undefined || editBtn == null){
        return;
    }

      let paramsData = [];
      let dataValues = val
      let params = {
          gmcUid: editBtn.pattern.gmcUid,
          dataUid: dataValues.uid,
          language: this.lang
      };
      ajax.post(api.POPUP, params).then(res => {
          this.subApiType = "edit";
          if(isModel == false){
              this.subvisible = false;
          }else{
              this.subvisible = true;
          }

          this.subQueryUpdatas = res;
          this.subQueryUpdatas.behrUid = editBtn.btnUid;
          this.subQueryUpdatas.dataUid = params.dataUid;
          this.subQueryUpdatas.lookupGmcuid = editBtn.pattern.gmcUid;
          this.subQueryUpdatas.lookupCode = editBtn.code;
          this.subQueryUpdatas.version = dataValues.version;
      });
  },
  tableChangePage(val) {
      this.subLoading = true;
      this.pagePadding.currentVal = val;
      this.subTableFun();
  },
  onShowSizeChange(current, pageSize) {
      this.subLoading = true;
      this.pagePadding.currentVal = current;
      this.pagePadding.pagingSize = pageSize;
      this.subTableFun();
  },
  //    操作固定width 需要重新渲染组件
  GetrederSub(val) {
      this.fixedNum = val;
      this.renderTable = this.renderTable + 1;
  },
  moment,
  getrenderSortVal(val) {
      this.subTableFunType = "sort";
      this.subTableFunInfo = val;
      this.subLoading = true;
      this.pagePadding.currentVal = 1
      this.subTableFun();
  },
  //      sub table表头搜索
  getredSearchVal(val) {
      this.subTableFunType = "tle";
      this.subLoading = true;

      let scParams = [];



      val.forEach((v, j) => {
        if(v.serVal){
          if( Array.isArray(v.serVal)){
            for(let i in v.serVal){
              scParams.push({ key: v.uid, value: v.serVal[i] });
            }
          }else{
            scParams.push({ key: v.uid, value: v.serVal });
          }
        }
      });

      this.subTableFunInfo = scParams;
      this.pagePadding.currentVal = 1
      this.subTableFun();
  },
  //    子表andvance search
  getrenderQueryVal(item) {
        let templateName  = item.tml
       if(templateName != undefined && templateName != null){
                  this.parTableTemplateName  = templateName 
        }
      this.subTableFunType = "qf";
      this.subTableFunInfo = item;
      this.pagePadding.currentVal = 1
      this.subTableFun();
  },
  //      何在一起
  subTableFun() {
      let params = {
          functionUid: this.$route.query.funcUid,
          gmcUid: this.subTableGmcuid,
          language: this.lang,
          isPopup:true,      
          userUid: this.$route.query.userUid,
          paging: {
              pageNum: this.pagePadding.currentVal,
              pageSize: this.pagePadding.pagingSize
          },
          params: [{ key: "uid", value: this.targetUID }]
      };
      if (this.subTableFunType == "sort") {
          params.userSortDtos = this.subTableFunInfo;
      } else if (this.subTableFunType == "tle") {
          params.columnSearch = this.subTableFunInfo;
      } else if (this.subTableFunType == "qf") {
          params.userSqlDto = this.subTableFunInfo.query;
          params.userSqlDto.gmcUid = this.subTableGmcuid
          params.template = this.subTableFunInfo.tml;
      }else{
        if (this.subTableFunInfo.length>0) {
          params.columnSearch = this.subTableFunInfo;
        }
      }
    // console.log("3:ssss");
      ajax.post(api.SKUSTAB, params).then(res => {
          if (res.code == 200) {
              this.subTableFunType = ''
              if (res.data.tableListDto.paging != null) {
                  this.pagePadding.pagingTotal =
                      res.data.tableListDto.paging.totalPageSize;
              }
              this.subLoading = false;
              this.subFunctionBtn = res.data.functionBtn;
              let arrFn =  this.subFunctionBtn
              for (let i in arrFn) {
                  let tt = arrFn[i].children;
                  for (let j in tt) {
                      if (tt[j].code == "BTN_EDIT") {
                          tt[j].editFlag = "1";
                      }
                  }
              }
              this.subData = res.data.tableListDto
              this.renderTable = this.renderTable + 1;
              for(let i in  this.subData.columns){
                  for(let t in this.subTableFunInfo){
                      if(this.subTableFunInfo[t] != null && this.subTableFunInfo[t].key != undefined && this.subTableFunInfo[t].key ==  this.subData.columns[i].label){
                          this.subData.columns[i].serVal =this.subTableFunInfo[t].value
                      }
                  }
              }
          } else {
              this.$customMessage.warning(res.msg, 3);
              this.subLoading = false;
          }
      });
  },

  //      TAb初始化数据
  initTabelList() {
    //Liyy 2021-11-4 根据Manual Allocation的名称找到对应的坐标,以供跳转到对应的Tab页面
    for (let i = 0; i < this.tabsData.length; i++) {
      if(this.tabsData[i].name == 'Manual Allocation'){
        this.manualAllocationIndex = i;
        break
      }
    }

      let that =this
      this.$nextTick(()=>{
//         离开页面是否保存
          let fromChangeVal = this.$refs.EditFromNbRefs.retunFromVal()
          if(fromChangeVal!=null  && (! this.notShowEditPageSaveBtn) ){
              this.$customConfirm({
                  title: 'You have unsaved changes. Do you want to leave and discard your changes?',
                  okText: 'Discard',
                  cancelText: 'Cancel',
                  onOk() {
                     that.initData()
                  },
                  onCancel() {
                      return
                  }
              });
          }else{
              this.initData()
          }
      })
  },
  initData(){
      //        父组件存在编辑 请求编辑数据
      if (this.targetActive == 'headerKey') {
          this.dataSearch = [];
          let patEdit = this.$parent.data.functionBtn;
           let editTargetObj = null;
          if (patEdit.length < 1) {
              this.$customMessage.warning(this.$t('publicLang.SystemAdministrator'), 3);
              return;
          }
          patEdit.forEach((v, i) => {
              v.children.forEach((j, h) => {
                  if (j.code == "BTN_EDIT") {
                      editTargetObj = j;
                  }
              });
          });


         if(editTargetObj == null){
           let  editBtnInfo  = this.$parent.data.editBtnInfo
            editTargetObj={};
            editTargetObj.btnUid = editBtnInfo.uid;
            editTargetObj.pattern ={};
            editTargetObj.pattern.gmcUid = editBtnInfo.gmcUid;
        }





          this.editTargetObj = editTargetObj;
          let params = {
              gmcUid: editTargetObj.pattern.gmcUid,
              dataUid: this.targetUID,
              language: this.lang
          };
          if (params.gmcUid == undefined) {
              this.$customMessage.error(this.$t('publicLang.SystemAdministrator'), 3);
          }
          ajax.post(api.POPUP, params).then(res => {
              this.headerFromData = res
              this.headerFromData.behrUid = this.editTargetObj.btnUid
              this.headerFromData.lookupGmcuid =  this.editTargetObj.pattern.gmcUid;
              this.headerFromData.notShowEditPageSaveBtn = this.notShowEditPageSaveBtn
          });
      } else {
          this.subLoading = true;
          let params = {
              userUid: this.$route.query.userUid,
              functionUid: this.$route.query.funcUid,
              language: this.lang,
              isPopup:true,
              gmcUid: this.tabsData[this.targetActive].gmcUid,
              paging: {
                  pageNum: this.pagePadding.currentVal,
                  pageSize: this.pagePadding.pagingSize
              },
              params: [
                  {
                      key: "uid",
                      value: this.targetUID
                  }
              ]
          };
          ajax.post(api.SKUSTAB, params).then(res => {
              if (res.code == 200) {
                  if (res.data.tableListDto.paging != null) {
                      this.pagePadding.pagingTotal = res.data.tableListDto.paging.totalPageSize;
                  }
                  this.subLoading = false;
                  this.subTableGmcuid = res.data.gmcUid;
                  this.subFunctionBtn = res.data.functionBtn;
                  let arrFn =  this.subFunctionBtn
                  for (let i in arrFn) {
                      let tt = arrFn[i].children;
                      for (let j in tt) {
                          if (tt[j].code == "BTN_EDIT") {
                              tt[j].editFlag = "1";
                          }
                      }
                  }
                  this.subData = res.data.tableListDto;
              } else {
                  this.$customMessage.warning(res.msg, 5);
                  this.subLoading = false;
                  return;
              }
          });
      }
    },
  //      获取子表格选中返回的值
  getSubBoxSelectData(v) {
      this.subCheckData = v;
  },
  //    子按钮事件
  subEventclickCall(val) {
      // update 更新
      let that = this
      if (val.code == "BTN_REFRESH") {
        this.subTableFunInfo = "";
          this.subTableFun();
      }
      if (val.code === "BTN_UPDATE"){
          if (this.subCheckData.length < 1) {
              this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
              return;
          }
          let that = this;
          this.$customConfirm({
              title: that.$t('publicLang.AreUpadte'),
              content: "",
              onOk() {
                  let deleteData = that.subCheckData;
                  let paramsData = [];
                  for (let index in deleteData) {
                      if (deleteData[index].uid != "") {
                          let paramsObj = {};
                          paramsObj.key = "uid";
                          paramsObj.value = deleteData[index].uid;
                          paramsData.push(paramsObj);
                          paramsData.push({
                              key: "version",
                              value: deleteData[index].version
                          });
                      }
                  }
                  let params = {
                      gmcUid: val.pattern.gmcUid,
                      params: paramsData,
                      type: "update",
                      language: that.lang,
                      behrUid: val.btnUid
                  };
                  ajax.post(api.UPDATE, params).then(res => {
                      if (res.code === 200) {
                          that.$message.success(res.msg);
                          that.subTableFun();
                      } else {
                          that.$customMessage.warning(res.msg);
                          that.$info({
                              title: res.msg,
                              okText: "Yes",
                              okType: "confirm",
                              cancelText: "No",
                              onOk() {
                                  that.subTableFun();
                              }
                          });
                      }
                  });
              }
          });
      }
      //        新增操作
      if (val.code === "BTN_ADD") {
          if ("BUTTON" == val.type && "editAttachment" == val.pattern.custPage){
            this.$refs.editAttachment.show(null,this.targetUID,this.pageType,this.nowTabIndex)
          } else {
              let params = {
                gmcUid: val.pattern.gmcUid,
                language: this.lang,
                partnerType: this.isExtraParam
            };
            ajax.post(api.POPUP, params).then(res => {
//                是否内部编辑
                if(val.isModel == false){
                    this.subvisible = false;
                }else{
                    this.subvisible = true;
                }
  
                this.subApiType = "add";
                this.subQueryUpdatas = res;
                this.subQueryUpdatas.behrUid = val.btnUid;
                this.subQueryUpdatas.uid = this.targetUID;
                this.subQueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                this.subQueryUpdatas.lookupCode = val.code;
            });
          }
                
      }
      if (val.code === "BTN_EDIT") {

          if (this.subCheckData.length != 1) {
              this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 5);
              return;
          }
          let paramsData = [];
          let dataValues = this.subCheckData[0];
          let params = {
              gmcUid: val.pattern.gmcUid,
              dataUid: dataValues.uid,
              language: this.lang
          };
          ajax.post(api.POPUP, params).then(res => {
              this.subApiType = "edit";
              this.subvisible = true;
              this.subQueryUpdatas = res;
              this.subQueryUpdatas.behrUid = val.btnUid;
              this.subQueryUpdatas.dataUid = params.dataUid;
              this.subQueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
              this.subQueryUpdatas.lookupCode = val.code;
              this.subQueryUpdatas.version = dataValues.version;
          });
      }
      if (val.code === "BTN_DELETE") {
          if (this.subCheckData.length < 1) {
              this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
              return;
          }
          let tt = [];
          for (let ii in this.subCheckData) {
              if (!this.subCheckData[ii].deletable) {
                  tt.push(this.subCheckData[ii].key + 1);
              }
          }
          if (tt.length > 0) {
              let cc;
              cc = tt.join(",");
              this.$customMessage.warning(
                  "[Row#"+cc+']'+this.$t('publicLang.NotAllowtodeleteCancel'),
                  5
              );
              return;
          }
          let that = this;
          this.$customConfirm({
              title: this.$t('pubGicSet.AreyoudeleTask'),
              okText: this.$t('publicLang.Confirm'),
              cancelText: this.$t('publicLang.Cancel'),
              content: "",
              onOk() {
                  let deleteData = that.subCheckData;
                  let paramsData = [];
                  for (let index in deleteData) {
                      if (deleteData[index].uid != "") {
                          let paramsObj = {};
                          paramsObj.key = "uid";
                          paramsObj.value = deleteData[index].uid;
                          paramsData.push(paramsObj);
                          paramsData.push({
                              key: "version",
                              value: deleteData[index].version
                          });
                      }
                  }
                  let params = {
                      gmcUid: val.pattern.gmcUid,
                      params: paramsData,
                      type: "delete",
                      language: that.lang,
                      behrUid: val.btnUid
                  };
				  
                  let apiUrl = api.UPDATE
               if(val.patternType == "EXT"){
                   apiUrl = val.externalApi
               }

                  ajax.post(apiUrl, params).then(res => {
                    if (res.code === 200) {
                      that.subCheckData = [];
                      that.subTableFun();
                      that.$message.success(that.$t("publicLang.DeleteSuccess"));
                    } else {
                      that.$customMessage.error(res.msg);
                    }
                  });
              }
          });
      }
      if (val.code == "BTN_EXPORT") {
          if (val.patternType == "EXT") {
              let ajaxurl = ajax.ajaxUrl();
              if(val.externalApi == api.DOWNLOADATTACHMENT) {
                  if (this.subCheckData.length < 1) {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
                    return;
                  }       
                  // 组装params
                  let exportData = this.subCheckData;
                  let paramsData = [];
                  for (let index in exportData) {
                    if (exportData[index].uid != "") {
                        let paramsObj = {};
                        paramsObj.key = "uid";
                        paramsObj.value = exportData[index].uid;
                        paramsData.push(paramsObj);
                    }
                  }
                  let params = {
                      gmcUid: val.pattern.gmcUid,
                      params: paramsData,
                      type: "export",
                      language: that.lang,
                      behrUid: val.btnUid
                  }
                  ajax.post(api.DOWNLOADATTACHMENT, params).then(res => {
                    if(res.code == 200) {
                        this.$message.success(res.msg);
                        let exportFileUrl = res.data;
                        exportFileUrl.forEach((value, index) => {
                            window.open(value);
                        });
                    } else {
                        this.$customMessage.warning(res.msg);
                    }
                  })
                } else {
                    axios.get(ajaxurl + val.externalApi, {
                        params: {
                            btnUid: val.btnUid,
                            language: this.lang
                        },
                        headers: {
                            Authorization: cookie.getBearerToken()
                        },
                        responseType: "blob" //二进制流
                    })
                  .then(function(data) {
                      if (!data) {
                          return;
                      }
                      var blob = new Blob([data.data], {
                          type:
                              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                      });
                      var url = window.URL.createObjectURL(blob);
                      var aLink = document.createElement("a");
                      aLink.style.display = "none";
                      aLink.href = url;
                      aLink.setAttribute("download", "excel.xlsx");
                      document.body.appendChild(aLink);
                      aLink.click();
                      document.body.removeChild(aLink); //下载完成移除元素
                      window.URL.revokeObjectURL(url); //释放掉blob对象
                  })
                  .catch(function(error) {
                      alert(error);
                  });
              }
              
          }

          if(val.viewType == "EXCEL"){
              let params = {
                  gmcUid: this.subTableGmcuid,
                  language: this.lang,
                  export: 'excel',
                  params:[{"key":"uid","value":this.targetUID}]
              }


              if(this.subTableFunInfo instanceof Array ){
                  params.columnSearch = this.subTableFunInfo
              }else{
                  params.userSqlDto = this.subTableFunInfo.query
              }
              let ajaxurl = ajax.ajaxUrl();
              ajax.exportExcel(ajaxurl+api.SKUS,params).then(data=>{
                  if (!data) {
                      return;
                  }
                  var blob = new Blob([data.data], {
                      type:
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                  });
                  var url = window.URL.createObjectURL(blob);
                  var aLink = document.createElement("a");
                  aLink.style.display = "none";
                  aLink.href = url;
                  aLink.setAttribute("download", "excel.xlsx");
                  document.body.appendChild(aLink);
                  aLink.click();
                  document.body.removeChild(aLink); //下载完成移除元素
                  window.URL.revokeObjectURL(url); //释放掉blob对象
              })
          }
      }
      if (val.code == "BTN_SAVE") {
          //            弹指定弹窗
          if(val.type == "POPUP" && val.pattern.custPage == "lookUp"){
              if (this.subCheckData.length != 1) {
                  this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3);
                  return;
              }
              let feildArr = []
              let dataValues = this.subCheckData[0]
              let feildPatternParams = val.pattern.params
              for (let ii in dataValues) {
                  for (let tt in feildPatternParams) {
                      if (ii == feildPatternParams[tt]) {
                          feildArr.push({key: ii, value: dataValues[ii].value})
                      }
                  }
              }
              let params = {
                  gmcUid: this.subTableGmcuid,
                  language: this.lang,
                  noEvent: true,
                  lookup: {
                      gmcUid: val.pattern.gmcUid,
                  }
              }
              params.feildArr = feildArr
              this.lookupParams = params;
              this.$refs.lookupRefs.showModal();
          }
          if(val.type == "BUTTON" && val.pattern.custPage == "enigeSort"){
              let obj = {
                  tableId: this.subTableGmcuid
              }
              this.$refs.sortTableRef.show(obj)
          }
          if (val.pattern.custPage == "De-allocation" && val.type == "BUTTON") {
              if (this.subCheckData.length < 1) {
                  this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                  return;
              }
              let params = [];

              for (let ii in this.subCheckData) {
                  params.push(this.subCheckData[ii].uid);
              }

              this.$refs.deAllocation.openModal(params);
          }
          if (val.pattern.custPage == "Batch_Update" && val.type == "BUTTON") {
              if (this.subCheckData.length < 1) {
                  this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                  return;
              }
              let Batchdata = this.subCheckData;
              let batchDataArr = [];
              for (let index in Batchdata) {
                  if (Batchdata[index].uid != "") {
                      let paramsObj = {};
                      paramsObj.key = "uid";
                      paramsObj.value = Batchdata[index].uid;
                      batchDataArr.push(paramsObj);
                      batchDataArr.push({
                          key: "version",
                          value: Batchdata[index].version
                      });
                  }
              }
              this.bathUpdatparams = {
                  gmcUid: val.pattern.gmcUid,
                  language: this.lang,
                  batchDataArr: batchDataArr,
                  btnUid: val.btnUid
              };
              this.$refs.subBathUpdateRefs.open();
          }
          if (val.type == "BUTTON" && val.patternType == "EXT") {
              let paramsData = [];
              if (val.pattern.params.length > 0) {
                  if (this.subCheckData.length < 1) {
                      this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                      return;
                  }
                  let SaveData = this.subCheckData;
                  let patterParams = val.pattern.params;
                  for (let index in SaveData) {
                      if (SaveData[index].uid != "") {
                          let paramsObj = {};
                          paramsObj.key = "uid";
                          paramsObj.value = SaveData[index].uid;
                          paramsData.push(paramsObj);
                      }
                  }
              }
              let params = {
                  behrUid: val.btnUid,
                  userUid: this.$route.query.userUid,
                  functionUid: this.$route.query.funcUid,
                  gmcUid: val.pattern.gmcUid,
                  params: paramsData,
                  language: this.lang
              };
              ajax.post(val.externalApi, params).then(res => {
                  if (res.code == 200) {
                      this.subTableFun();
                      this.$message.success(res.msg, 5);
                  } else {
                      this.$customMessage.warning(res.msg, 5);
                  }
              });
          }
          if(val.pattern.custPage == "Split" && val.type == "BUTTON"){
              if (this.subCheckData.length != 1) {
                  this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3);
                  return;
              }else{
                  this.$refs.splitRef.showSplit(this.subCheckData[0].uid)
              }
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "Sort"){
              this.$refs.modalSortTableRef.show(this.subData.columns,this.subData.data,this.subTableGmcuid )
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "editTable"){ // receive deatil table 快速
              this.$refs.editTableRef.show(this.targetUID)
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "CreateFromInventory"){
            this.$refs.createFromInventory.show(this.targetUID)
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "soEditTable"){
              this.$refs.soEditTableRef.show(this.targetUID)
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "createTicket") {
                this.$refs.createTicket.show(this.targetUID)
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "createTicketByNewOrReCount") {
            this.$refs.createTicketByNewOrReCount.show(this.targetUID)
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "assignedUser") {
            if (this.subCheckData.length < 1) {
                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
                return;
            }
            var assigned = [];
            var assignedFlag = 'false';
            var statusFlag = 'true';
            var information = 'Below Ticket(s) already assigned user. Confirm to change user?';
            var content = '<div>';
            let that = this;
            // 找出勾选的所有已经Assigned的Tacket No
            var ticketIndex = 0;
            var assignedUserIndex = 0;
            var statusIndex = 0;

            let uidArr = [];

            for(var now of this.subCheckData) {
              uidArr.push(now.uid);
            }

            let params = {
              "uidArr": uidArr
            };

            ajax.post(api.INVENTORYCYCLECOUNTQUERYTICKETINFO, params).then(res => {
              if(res.data != null){
                for(var now of res.data) {
                  if(undefined != now.assignedUser && null != now.assignedUser && '' != now.assignedUser ) {
                    content += now.assignedUser ;
                    content += '<br>';
                    assignedFlag = 'true';
                  }
                  // 判断是不是全部都是新建状态
                  if (now.status != '00' ) {
                    statusFlag = 'false';
                  }
                  assigned.push(now.ticketNo);
                }

                content += '</div>';
                // 判断是否全部都是New状态
                if ( statusFlag == 'true' ) {
                  // 如果存在已经Assigned的数据
                  if ( assignedFlag == 'true' ) {
                    this.$confirm({
                      title: information,
                      content: (h) => {return h('div', {domProps: {innerHTML: content},}, []);},
                      okText: 'Yes',
                      okType: 'confirm',
                      width: 600,
                      cancelText: 'No',
                      onOk() {
                        that.$refs.assignedUser.show(that.targetUID, assigned, that.nowTabIndex);
                      },
                    })
                    return
                  } else {
                    that.$refs.assignedUser.show(that.targetUID, assigned, that.nowTabIndex);
                  }
                } else {
                  // 提示错误信息
                  this.$customMessage.warning('Data in a non-new state exists.');
                }
              }
            });



            
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "quick-Allocation"){
              this.$refs.soAllocationTabRef.show(this.targetUID)
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "createPallet"){
              if (this.subCheckData.length < 1) {
                  this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
                  return;
              }
              let uids = [];
              for (let index in this.subCheckData){
                  uids.push(this.subCheckData[index].uid)
              }
              this.$refs.addConsignmentRefs.show('ULD#','createPallet',uids)
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "createShipment"){
              if (this.subCheckData.length < 1) {
                  this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 5);
                  return;
              }
              let uids = [];
              for (let index in this.subCheckData){
                  uids.push(this.subCheckData[index].uid)
              }
              this.$refs.addConsignmentRefs.show('MAWB','createShipment',uids)
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "palletDetail"){
              let params = {
                  btnUid: val.btnUid,
                  userUid: this.$route.query.userUid,
                  language: this.lang,
                  fieldMapUid: val.mapUid,
                  importTitle: val.name,
                  targetUID: this.targetUID,
                  gmcUid: val.pattern.gmcUid,
                  palletType: 'palletDetail'
              };
              this.importparams = params;
              this.addPalletVisible = true;
          }
          if (val.type == "BUTTON" && val.pattern.custPage == "shipmentDetail"){
              let params = {
                  btnUid: val.btnUid,
                  userUid: this.$route.query.userUid,
                  language: this.lang,
                  fieldMapUid: val.mapUid,
                  importTitle: val.name,
                  targetUID: this.targetUID,
                  gmcUid: val.pattern.gmcUid,
                  palletType: 'shipmentDetail'
              };
              this.importparams = params;
              this.addPalletVisible = true;
          }
        if (val.type == "BUTTON" && val.pattern.custPage == "ManualAllocation"){//Liyy 2021-11-4 手动分配
          if (this.subCheckData.length != 1) {
            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3);//只能选择一条记录
            return;
          }
          let uidList = []
          for(let i in this.subCheckData){
            uidList.push(this.subCheckData[i].uid);
          }
          if(uidList.length > 0){
            this.manualAllocationUidList = uidList;
          }
          this.subCheckData = [];//清空Tab页面选中行数据
          this.JumpManualAllocation(uidList);
        }
        if (val.type == "BUTTON" && val.pattern.custPage == "ConfirmManualAllocation"){//Liyy2021-11-9 确认手动分配
          if (this.subCheckData.length != 1) {
            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3);//只能选择一条记录
            return;
          }
          if(this.subCheckData[0].allocateQty == null || this.subCheckData[0].allocateQty < 1){
            this.$customMessage.warning(this.$t('soPage.inputAllQty'), 3);//请输入分配数量
            return;
          }
          let avQtyId = "";
          let invUidId = "";
          let lotIdInv = "";
          for (let i = 0; i < this.subData.columns.length; i++) {
            if(this.subData.columns[i].flag == 'AV_QTY'){
              avQtyId = this.subData.columns[i].label;
            }
            if(this.subData.columns[i].flag == 'INV_UID'){
              invUidId = this.subData.columns[i].label;
            }
            if(this.subData.columns[i].flag == 'LOT_ID'){
              lotIdInv = this.subData.columns[i].label;
            }
          }
		  
	 if(avQtyId == null || avQtyId.length == 0){
            this.$customMessage.warning('Configuration error, AV QTY cannot be recognized')
            return;
        }

     if(invUidId == null || invUidId.length == 0){
            this.$customMessage.warning('Configuration error, INV UID cannot be recognized')
            return;
        }


     if(lotIdInv == null || lotIdInv.length == 0){
            this.$customMessage.warning('Configuration error, LOT ID cannot be recognized')
            return;
        }

		  
		  
          if(avQtyId > 0){
            if(this.subCheckData[0].allocateQty > this.subCheckData[0][avQtyId].value){
              this.$customMessage.warning(this.$t('wine.AvailableQty'), 3);//輸入數量超出有效庫存數量
              return;
            }
            let invUid = this.subCheckData[0][invUidId].value;
            let allQty = this.subCheckData[0].allocateQty;
            let lotId = this.subCheckData[0][lotIdInv].value;
            this.confirmManualAllocation(invUid,allQty,this.manualAllocationUidList[0],lotId);
          }
        }
      }
      if (val.code == "BTN_IMPORT") {
          let params = {
              btnUid: val.btnUid,
              userUid: this.$route.query.userUid,
              language: this.lang,
              fieldMapUid: val.mapUid,
              importTitle: val.name,
              isMove: val.pattern.custPage,
//              子表inport 需要父表uid
              targetUID: this.targetUID
          };

          if (val.type == "POPUP" && val.viewType == "LIST") {
              params.importType = "DB";
              params.gmcUid = val.pattern.gmcUid;
          }
          if (val.type == "File" && val.viewType == "EXCEL"){
              params.importType = "excel";
              params.gmcUid = val.pattern.gmcUid;
          }
          this.importparams = params;
          this.importVisible = true;
      }
      if (val.code == "BTN_PRINT") {
        if (val.viewType == "LIST") {
            if (this.subCheckData.length < 1) {
                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                return;
            }
        } else {
            if (this.subCheckData.length != 1) {
                this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                return;
            }
        }
        
        let tt = [];
        for (let ii in this.subCheckData) {
            console.log(this.subCheckData[ii]);
            tt.push(this.subCheckData[ii].uid);
        }
        // 打印预览
        this.printPreview(tt,val);
      }
  },
//    sortTable 成功刷新
    GetSortTableData(v){
        if(v == 'columnSetting'){
            this.subData = {}
        }
        this.initTabelList();
    },
//  import 后接受数据刷新
    GETcancelImport(val) {
        this.importVisible = false;
        this.addPalletVisible = false
        if (val == "init") {
            this.initTabelList();
        }
    },
  //      bathch 返回data
  GETcancelModalVisible(val) {
      if (val != "close") {
          this.subTableFun();
      }
  },
  //    接受弹窗返回的值
  getSubvidible(v) {
      if (v == "close") {
          this.subvisible = false;
      } else if (v == "init") {
          this.subvisible = false;
          this.initTabelList();
      }
  },
//    打开drawer
  showDawer(version) {
      this.drawerVisible = true;
      this.initTabelList();
  },
//    关闭drawer
  onCloserDawer() {
        // 删除搜索框里的所有内容
      this.subTableFunInfo = "";
      this.targetActive = 'headerKey';
      this.$refs.EditFromNbRefs.closeClearform()
      this.drawerVisible = false;
      this.$store.commit("updataPartStatus", { partStatus: null });
      this.$store.commit("updataTabsTitle", { tabsTitle: null });
  },
  //   tab切换请求数据
  tabClickEvent(val) {
    if(val == this.manualAllocationIndex){
        this.tabType = "ManualAllocation";
        this.subData = {};
        return;//如果直接点击Manual Allocation Tab页面则不显示数据
      }else{
        this.tabType = "";
      }
      this.subTableFunInfo = "";
      let that = this
      let comsfromChangeVal = this.$refs.EditFromNbRefsComs
      if(comsfromChangeVal && comsfromChangeVal.length > 0){
          let flag = false
          for(let i in  comsfromChangeVal){
              if(comsfromChangeVal[i].retunFromVal() !=null){
                  flag = true
              }
          }

          if(flag){
              this.$customConfirm({
                  title: 'You have unsaved changes. Do you want to leave and discard your changes?',
                  okText: 'Discard',
                  cancelText: 'Cancel',
                  onOk() {
                      for(let i in  comsfromChangeVal){
                          comsfromChangeVal[i].clearchangVal()
                      }
                      that.targetActive = val;
                      that.tabData(val)
                  },
                  onCancel() {
                      that.targetActive = that.lastActie
                      return
                  }
              });
              return
          }
      }

      this.subData = {};
      this.targetActive = val;
      this.lastActie = val


//      离开页面是否保存
      if(this.$refs.EditFromNbRefs  && (! this.notShowEditPageSaveBtn) ){
        let fromChangeVal = this.$refs.EditFromNbRefs.retunFromVal()
          if(fromChangeVal!=null){
              this.$customConfirm({
                  title: 'You have unsaved changes. Do you want to leave and discard your changes?',
                  okText: 'Discard',
                  cancelText: 'Cancel',
                  onOk() {
                      that.$refs.EditFromNbRefs.clearchangVal()
                      that.tabData(val)
                  },
                  onCancel() {
                      that.targetActive = 'headerKey'
                      return
                  }
              });
          }else{
              that.tabData(val)
          }
      }else{
          that.tabData(val)
      }
  },
    tabData(val){
        this.nowTabIndex = val;
        // console.info('切换  tabs 的时候触发')
        if (this.targetActive == 'headerKey') {
            this.initTabelList();
            return;
        }

        this.pagePadding.currentVal = 1;
//        转参数内部编辑
        if(this.tabsData[val].extraParam != null &&  this.tabsData[val].extraParam != ''){
            this.isExtraParam = this.tabsData[val].extraParam
        }else{
            this.isExtraParam = ''
        }
//        一般情况去指定页面
        if(this.tabsData[val].extraParam == 'ruleEnigeDetail' || this.tabsData[val].extraParam == 'Cron'){
            this.subData.columns = []
            return
        }
        let params = {
            userUid: this.$route.query.userUid,
            functionUid: this.$route.query.funcUid,
            language: this.lang,
            isPopup:true,      
            gmcUid: this.tabsData[val].gmcUid,
            paging: {
                pageNum: this.pagePadding.currentVal,
                pageSize: this.pagePadding.pagingSize
            },
            params: [
                {
                    key: "uid",
                    value: this.targetUID
                }
            ]
        };
      ajax.post(api.SKUSTAB, params).then(res => {
            if(res.code == 1000){
                return
            }

            if (res.data.tableListDto.paging != null) {
                this.pagePadding.pagingTotal = res.data.tableListDto.paging.totalPageSize;
            }
            this.subTableGmcuid = res.data.gmcUid;
            this.subFunctionBtn = res.data.functionBtn;
            let arrFn =  this.subFunctionBtn
            for (let i in arrFn) {
                let tt = arrFn[i].children;
                for (let j in tt) {
                    if (tt[j].code == "BTN_EDIT") {
                        tt[j].editFlag = "1";
                    }
                }
            }
            this.subData = res.data.tableListDto;
          

        if(this.tabsData[val].extraParam == undefined || this.tabsData[val].extraParam == null ||  this.tabsData[val].extraParam == '' ){     // 当页面没有配置  extraParam  时， 不执行下面的代码
            return;
        }

            this.isExtraParam = this.tabsData[val].extraParam
            let tt = this.subData.data          //  查询返回的数据
                if(tt.length == 0){            // 当没有数据的时候.跳转新增页面
                    let subFun = this.subFunctionBtn
                    let addBtn = {}
                    for(let ii in subFun){
                        for(let tt in subFun[ii].children){
                            if(subFun[ii].children[tt].code == 'BTN_ADD'){
                                addBtn = subFun[ii].children[tt]
                                addBtn.isModel = false
                            }
                        }
                    }
                    this.subEventclickCall(addBtn)
                    return
                }else{               // 查询返回存在数据

                  for(let i in  tt){        // 遍历每一条数据
                        if(tt[i].partnerType == this.isExtraParam){      // 获取数据类型和目标的数据类型是否一致， 一直即打开编辑页面  并结束循环
                            this.isExtraParType = tt[i]
                            this.dbSelectSubTableChange(this.isExtraParType,false)
                            return
                        }
                    }
                    //  全部数据和目标的数据类型  都不一致，打开新建页面
                      let subFun = this.subFunctionBtn
                      let addBtn = {}
                      for(let ii in subFun){
                          for(let tt in subFun[ii].children){
                              if(subFun[ii].children[tt].code == 'BTN_ADD'){
                                  addBtn = subFun[ii].children[tt]
                                  addBtn.isModel = false
                              }
                          }
                      }
                      this.subEventclickCall(addBtn)
                        
                }
        });
    },
  JumpManualAllocation(uidList){
    this.tabType = "ManualAllocation";
    this.targetActive = this.manualAllocationIndex;//跳转到对应的Tab页面
    this.subData = {};
    this.lastActie = this.manualAllocationIndex;
    let param = {
      gmcUid: this.tabsData[this.manualAllocationIndex].gmcUid
    };
    ajax.post(api.GETFIELDNAMEDROPDATA, param).then(res => {
      if(res.data != null){
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].fieldName == 'SOD UID'){
            this.tabDataSpecial(this.manualAllocationIndex,uidList,res.data[i].detailUid)//item.detailUid
            break;
          }
        }
      }
    });
  },
  tabDataSpecial(val,uidList,flName){
    if (this.targetActive == 'headerKey') {
      this.initTabelList();
      return;
    }
    this.pagePadding.currentVal = 1;
//        转参数内部编辑
    if(this.tabsData[val].extraParam != null &&  this.tabsData[val].extraParam != ''){
      this.isExtraParam = this.tabsData[val].extraParam
    }else{
      this.isExtraParam = ''
    }
//        一般情况去指定页面
    if(this.tabsData[val].extraParam == 'ruleEnigeDetail' || this.tabsData[val].extraParam == 'Cron'){
      this.subData.columns = []
      return
    }
    let params = {
      userUid: this.$route.query.userUid,
      functionUid: this.$route.query.funcUid,
      language: this.lang,
      isPopup:true,
      gmcUid: this.tabsData[val].gmcUid,
      paging: {
        pageNum: this.pagePadding.currentVal,
        pageSize: this.pagePadding.pagingSize
      },
      params: [
        {
          key: "uid",
          value: this.targetUID
        }
      ]
    };
    if(uidList != null && uidList.length > 0){
      let rules = []
      for (let i = 0; i < uidList.length; i++) {
        let rule = {
          boolValue: false,
          flName: flName,
          flType: "String",
          numVal: "",
          operator: "=",
          required: false,
          textSearchval: uidList[i] + "@##@",
          timeValue: ""
        }
        rules.push(rule);
      }
      let userSqlDto = {
        condition:"AND",
        gmcUid:this.tabsData[val].gmcUid,
        rules:[
          {
            condition: "OR",
            rules:rules
          }
        ]
      }
      if(flName > 0){
        params.userSqlDto = userSqlDto
      }
    }
    ajax.post(api.SKUSTAB, params).then(res => {
      if (res.data.tableListDto.paging != null) {
        this.pagePadding.pagingTotal = res.data.tableListDto.paging.totalPageSize;
      }
      this.subTableGmcuid = res.data.gmcUid;
      this.subFunctionBtn = res.data.functionBtn;
      let arrFn =  this.subFunctionBtn
      for (let i in arrFn) {
        let tt = arrFn[i].children;
        for (let j in tt) {
          if (tt[j].code == "BTN_EDIT") {
            tt[j].editFlag = "1";
          }
        }
      }
      this.subData = res.data.tableListDto;


      let tt = this.subData.data
      if(this.tabsData[val].extraParam != null &&  this.tabsData[val].extraParam != ''){
        this.isExtraParam = this.tabsData[val].extraParam
      }else{
        this.isExtraParam = ''
      }
      if(this.isExtraParam == ''){
        return
      }else{
        if(tt.length == 0){
          let subFun = this.subFunctionBtn
          let addBtn = {}
          for(let ii in subFun){
            for(let tt in subFun[ii].children){
              if(subFun[ii].children[tt].code == 'BTN_ADD'){
                addBtn = subFun[ii].children[tt]
                addBtn.isModel = false
              }
            }
          }
          this.subEventclickCall(addBtn)
          return
        }
//              不知道这是干嘛的咯
        for(let i in  tt){
          if(tt[i].partnerType == this.isExtraParam){
            this.isExtraParType = tt[i]
            this.dbSelectSubTableChange(this.isExtraParType,false)
            return
          }else{
            let subFun = this.subFunctionBtn
            let addBtn = {}
            for(let ii in subFun){
              for(let tt in subFun[ii].children){
                if(subFun[ii].children[tt].code == 'BTN_ADD'){
                  addBtn = subFun[ii].children[tt]
                  addBtn.isModel = false
                }
              }
            }
            this.subEventclickCall(addBtn)
          }
        }
      }
    });
  },
    // input 中lookuo 废弃以后删除
  lookupSearch(item) {
      let patEdit = this.$parent.data.functionBtn;
      let editTargetObj = {};
      patEdit.forEach((v, i) => {
          v.children.forEach((j, h) => {
              if (j.code == "BTN_EDIT") {
                  editTargetObj = j;
              }
          });
      });
      let params = {
          gmcUid: editTargetObj.pattern.gmcUid,
          language: this.lang,
          feildArr: [],
          lookup: {
              dataUid: "",
              gmcUid: item.FieldPattern.gmcUid,
              mapUid: item.mapUid,
              params: []
          }
      };
      let feildArr = []
//      获取值传到lookup
      this.form.validateFields((err, values) => {
          let filterParams = this.dataSearch;
          filterParams.forEach((v, i) => {
              for (let tt in values) {
                  if (parseInt(v.detailUid) == tt) {
                      if (v.fieldType == "Date") {
                          values[tt] = values[tt].format("YYYY-MM-DD");
                      }
                      if (v.fieldType == "Datetime") {
                          values[tt] = values[tt].format("YYYY-MM-DD HH:mm:ss");
                      }
                  }
              }
          });
          let feildPatternParams = item.FieldPattern.params
          for (let ii in values) {
              for(let tt in feildPatternParams){
                  if(ii == feildPatternParams[tt]){
                      feildArr.push({key: ii,value: values[ii]})
                  }
              }
              if (values[ii] != null) {
                  params.lookup.params.push({ key: ii, value: values[ii] });
              }
          }
          if (editTargetObj.code == "BTN_EDIT") {
              params.lookup.dataUid = this.targetUID;
          }
          if (params.gmcUid == undefined) {
              this.$customMessage.error(this.$t('publicLang.SystemAdministrator'), 3);
              return;
          }
          params.feildArr = feildArr
          this.lookupParams = params;
          this.$refs.lookupRefs.showModal();
      });
  },
//    lookup 返回的值 废弃以后删除
  getPropsLookup(params) {
      ajax.post(api.POPUP, params).then(res => {
          this.targetEditUid = res.uid;
          this.partEditBtnfn = res.functionBtn;
          this.dataSearch = res.data;
          this.defaultImg = ""; // 清空图片
          for (let ii in this.dataSearch) {
              this.dataSearch[ii].detailUid = this.dataSearch[ii].detailUid + "";
              if (this.dataSearch[ii].fieldType == "Image") {
                  this.defaultImg = {};
                  this.defaultImg.absolutelyUrl = this.dataSearch[
                      ii
                      ].DefaultValue.absoluteUrl;
                  this.defaultImg.url = this.dataSearch[ii].DefaultValue.url;
                  this.defaultImg.fileName = this.dataSearch[ii].DefaultValue.name;
                  this.defaultImg.detailUid = this.dataSearch[ii].detailUid;
              }
          }
      });
  },
    //      编辑提交 废弃暂时保留着
    partEditClick(item) {
        this.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let filterParams = this.dataSearch
                filterParams.forEach((v, i) => {
                    for (let tt in values) {
                        if (parseInt(v.detailUid) == tt) {
                            if (v.fieldType == "Date") {
                                if (values[tt] != null) {
                                    values[tt] =values[tt].format('YYYY-MM-DD')
                                }
                            }
                            if (v.fieldType == "Datetime") {
                                if (values[tt] != null) {
                                    values[tt] =values[tt].format('YYYY-MM-DD HH:mm:ss')
                                }
                            }
                        }
                    }
                });
                let paramsData = [];
                for (let key in values) {
                    let paramsObj = {};
                    paramsObj.key = key;
                    paramsObj.value = values[key];
                    paramsData.push(paramsObj);
                }

                if (item.type == "BUTTON" && item.patternType == "INT") {
                    paramsData.push({ key: "uid", value: this.targetEditUid });
                    paramsData.push({ key: "version", value: this.partversion });
                    let params = {
                        behrUid: this.editTargetObj.btnUid,
                        gmcUid: item.gmcUid,
                        params: paramsData,
                        type: "update",
                        language: this.lang,
                        userUid: this.$route.query.userUid,
                        functionUid: this.$route.query.funcUid
                    };
                    ajax.post(api.UPDATE, params).then(res => {
                        this.partversion++;
                        if (res.code === 200) {
                            this.$message.success(res.msg, 5);
                            this.$parent.init("editok");
                        } else {
                            let that = this;
                            this.$customMessage.warning(res.msg, 5);
                            this.$customConfirm({
                                title: res.msg,
                                okText: "Yes",
                                okType: "confirm",
                                cancelText: "No",
                                onOk() {
                                    that.initTabelList();
                                }
                            });
                        }
                    });
                }
            }
        });
    },
    confirmManualAllocation(invUid,allQty,sodUid,lotId){
      let params = new FormData();
      params.append("invUid", invUid);
      params.append("sodUid", sodUid);
      params.append("allQty", allQty);
      params.append("lotId", lotId);
      ajax.post(api.CONFIRMMANUALALLOCATION, params).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg, 5);
          this.subCheckData = [];//清空Tab页面选中行数据
          //确认分配后刷新页面
          this.JumpManualAllocation(this.manualAllocationUidList);
        } else {
          this.$customMessage.warning(res.msg, 5);
        }
      });
    },
    setPageType(pageType){
        this.pageType = pageType;
    },
    printPreview(tt,val){
        console.log(this.tabsData[this.targetActive]);
        let ajaxurl = ajax.ajaxUrl();
        let that = this;
        this.isBtnajax = true
        console.log("print---start"+tt.toString());
        console.log("print---start"+tt.length);
        axios.post(ajaxurl + api.PRINTPREVIEW, {
                gmcUid: this.tabsData[this.targetActive].gmcUid,
                uid: tt.toString(),
                btnName: val.name,
                btnUid: val.btnUid
            }, {
            headers: {
                Authorization: cookie.getBearerToken()
            },
            responseType: "blob" //二进制流
        }).then(function(res) {
            let resHeader = res.headers;
            let contentType = resHeader["content-type"];
            let excelContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
            if(excelContentType.indexOf(contentType) !=-1) {
                //excel
                that.isBtnajax = false
                var data  = res;
                if (!data) {
                    return;
                }
                var blob = new Blob([data.data], {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                });
                var url = window.URL.createObjectURL(blob);
                var aLink = document.createElement("a");
                aLink.style.display = "none";
                aLink.href = url;
                aLink.setAttribute("download", "excel.xlsx");
                document.body.appendChild(aLink);
                aLink.click();
                document.body.removeChild(aLink); //下载完成移除元素
                window.URL.revokeObjectURL(url); //释放掉blob对象
            } else {
                //pdf
                that.pubPdfMsgfn(res);
            }
        });
    },
    // paf接口返回值处理
    pubPdfMsgfn(res){
        let data = res.data;
        let fileReader = new FileReader();
        let that = this
        fileReader.onload = function() {
            try {
                let jsonData = JSON.parse(this.result);
                if (jsonData.code) {
                    that.$customMessage.warning(jsonData.msg);
                    that.$store.commit("updataLoading", { pbLoading: false });
                    that.isBtnajax = false
                }
            } catch (err) {
                that.pubPdfUploadOk(res)
            }
        };
        fileReader.readAsText(data)
    },
    pubPdfUploadOk(data){
        this.isBtnajax = false
        this.$store.commit("updataLoading", { pbLoading: false });
        let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
        let url = window.URL.createObjectURL(blob);
        window.open(url);
    },
}
};
</script>
<style lang="less">
  .tabsTables{
    position: fixed;
    width: 60%;
    height: 100%;
    background: #fff;
    top:0;
    right: 0;
    z-index:999;
    border-left:1px solid #efefef;
    border-radius:8px 0 0 8px;
    .tabeHeader{
      padding: 14px;
      border-bottom:1px solid #efefef;
    }
    .ant-tabs-nav .ant-tabs-tab-active{
      background: #2B9ED6;
      color: #fff;
    }
  }
.ant-collapse > .ant-collapse-item > .ant-collapse-header{
line-height: 16px;
}
</style>
